import { useReducedMotion, type Transition } from "motion/react";
import { FC } from "react";

import {
  MOTION_EASE_STANDARD,
  UI_TRANSITION_SECONDS,
  type IProfileListCompanyDto,
} from "@ryde/shared";

import { ProfileModalCompaniesItem } from "./profile.modal.companies.item";
import { ProfileModalCompaniesStyled } from "./profile.modal.styled";

const profileCompaniesListTransition = {
  duration: UI_TRANSITION_SECONDS.profileCompaniesList,
  delay: UI_TRANSITION_SECONDS.profileCompaniesListDelay,
  ease: MOTION_EASE_STANDARD,
} satisfies Transition;

interface IProfileModalHead {
  companies: IProfileListCompanyDto[] | undefined;
}

export const ProfileModalCompanies: FC<IProfileModalHead> = ({ companies }) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <ProfileModalCompaniesStyled
      initial={shouldReduceMotion ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={profileCompaniesListTransition}
    >
      {companies?.map(company => (
        <ProfileModalCompaniesItem key={company.id} item={company} />
      ))}
    </ProfileModalCompaniesStyled>
  );
};
